function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  padding: 18px 15px;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MenuIcon from './MenuIcon';
import Text from '../../atoms/Text';
import { defaultTheme } from '../../../utils';
var MenuHeaderWrapper = styled.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.text.bodyTextDark;
});

var MenuHeader = function MenuHeader(_ref2) {
  var name = _ref2.name,
      menuIcon = _ref2.menuIcon,
      rest = _objectWithoutPropertiesLoose(_ref2, ["name", "menuIcon"]);

  return /*#__PURE__*/React.createElement(MenuHeaderWrapper, rest, /*#__PURE__*/React.createElement(MenuIcon, {
    name: menuIcon
  }), /*#__PURE__*/React.createElement(Text, {
    referenceClass: "title",
    variant: "semiBold",
    text: name
  }));
};

MenuHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  menuIcon: PropTypes.string
} : {};
MenuHeader.defaultProps = {
  theme: defaultTheme,
  name: ''
};
export default MenuHeader;